import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'app-form-field-wrapper',
    templateUrl: './form-field-wrapper.component.html',
    styleUrls: ['./form-field-wrapper.component.scss'],
    standalone: false
})
export class FormFieldWrapperComponent extends FieldWrapper {}
